<template>
  <span
    class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold"
    :class="[badgeClass, sizeClass]"
  >
    <MTIcon :name="iconName" :size="iconSize" />
    <span v-if="showLabel">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";
import MTIcon from "@/components/ui/MTIcon.vue";

const props = defineProps({
  band: {
    type: String,
    default: "beginner",
    validator: (v) => ["beginner", "developing", "secure", "confident", "mastery"].includes(v)
  },
  size: {
    type: String,
    default: "md",
    validator: (v) => ["sm", "md", "lg"].includes(v)
  },
  showLabel: {
    type: Boolean,
    default: true
  }
});

const bandConfig = {
  beginner: {
    label: "Getting Started",
    icon: "star",
    class: "bg-blue-100 text-blue-700"
  },
  developing: {
    label: "Developing",
    icon: "sprout",
    class: "bg-green-100 text-green-700"
  },
  secure: {
    label: "Secure",
    icon: "book-open",
    class: "bg-yellow-100 text-yellow-700"
  },
  confident: {
    label: "Confident",
    icon: "rocket",
    class: "bg-orange-100 text-orange-700"
  },
  mastery: {
    label: "Mastery",
    icon: "crown",
    class: "bg-purple-100 text-purple-700"
  }
};

const config = computed(() => bandConfig[props.band] || bandConfig.beginner);

const label = computed(() => config.value.label);
const iconName = computed(() => config.value.icon);
const badgeClass = computed(() => config.value.class);

const sizeClass = computed(() => ({
  sm: "text-[10px] px-1.5 py-0.5",
  md: "text-xs px-2 py-0.5",
  lg: "text-sm px-3 py-1"
})[props.size]);

const iconSize = computed(() => ({
  sm: 10,
  md: 12,
  lg: 16
})[props.size]);
</script>
